import React from 'react';
import Link from '@material-ui/core/Link';

export default function ExternalLink({ url, className, children }) {
    return (
        <Link
            className={className}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </Link>
    );
}
